import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceReport from './ServiceReport.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'service-report',
    name:
      'ServiceReport',
    component: ServiceReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
